// client/src/api/userApi.js

// // עדכון סטטוס קורס
export const updateCourseStatus = async (courseId, status, progress = 0) => {
  try {
    const response = await customFetch.patch("/users/course-status", {
      courseId,
      status,
      progress,
    });

    return {
      success: true,
      ...response.data,
    };
  } catch (error) {
    console.error("Update Course Status API Error:", error);
    return {
      success: false,
      message:
        error.response?.data?.message || "שגיאת רשת. בדוק את החיבור לאינטרנט",
    };
  }
};


// client/src/api/userApi.js - עם פונקציות אימות מייל חדשות
import customFetch from "./customFetch";

// ========================================
// פונקציות קיימות (נשמרות לתאימות לאחור)
// ========================================

// קבלת רשימת הסקטורים
export const getSectors = async () => {
  try {
    const response = await customFetch.get("/users/sectors");
    return response.data;
  } catch (error) {
    console.error("Error getting sectors:", error);
    throw error;
  }
};

// התחברות משתמש רגיל
export const loginUser = async (credentials) => {
  try {
    const response = await customFetch.post("/users/login", credentials);
    return response.data;
  } catch (error) {
    console.error("Error logging in user:", error);
    throw error;
  }
};

// התחברות מנהל
export const loginAdmin = async (credentials) => {
  try {
    const response = await customFetch.post("/users/admin-login", credentials);
    return response.data;
  } catch (error) {
    console.error("Error logging in admin:", error);
    throw error;
  }
};

// התנתקות
export const logoutUser = async () => {
  try {
    const response = await customFetch.post("/users/logout");
    return response.data;
  } catch (error) {
    console.error("Error logging out:", error);
    throw error;
  }
};

// קבלת פרופיל משתמש
export const getUserProfile = async () => {
  try {
    const response = await customFetch.get("/users/profile");
    return response.data;
  } catch (error) {
    console.error("Error getting user profile:", error);
    throw error;
  }
};

// בדיקת אימות
export const checkAuth = async () => {
  try {
    const response = await customFetch.get("/users/check-auth");
    return response.data;
  } catch (error) {
    console.error("Error checking auth:", error);
    throw error;
  }
};

// רישום ישן (לתמיכה לאחור - לא מומלץ)
export const registerUser = async (userData) => {
  try {
    const response = await customFetch.post("/users/register-legacy", userData);
    return response.data;
  } catch (error) {
    console.error("Error registering user (legacy):", error);
    throw error;
  }
};

// איפוס סיסמה
export const resetPassword = async (resetData) => {
  try {
    const response = await customFetch.post("/users/reset-password", resetData);
    return response.data;
  } catch (error) {
    console.error("Error resetting password:", error);
    throw error;
  }
};

// ========================================
// פונקציות חדשות - אימות מייל (מומלץ)
// ========================================

/**
 * שלב 1: בקשת אימות מייל (במקום רישום ישיר)
 * @param {Object} userData - נתוני המשתמש (שם, מייל, סיסמה וכו')
 * @returns {Promise} תוצאת הבקשה
 */
export const requestEmailVerification = async (userData) => {
  try {
    console.log("🌐 Making API call to /users/request-verification");
    console.log("📦 userData:", userData);
    
    const response = await customFetch.post('/users/request-verification', userData);
    
    console.log("✅ API Response:", response.data);
    return response.data;
    
  } catch (error) {
    console.error('❌ Error requesting email verification:', error);
    throw error;
  }
};

/**
 * שלב 2: אימות קוד ויצירת משתמש
 * @param {Object} verificationData - { email, verificationCode }
 * @returns {Promise} תוצאת האימות ויצירת המשתמש
 */
export const verifyEmailAndRegister = async (email, verificationCode) => {
  try {
    const response = await customFetch.post('/users/verify-and-register', {
      email,
      verificationCode
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying email:', error);
    throw error;
  }
};

/**
 * שליחת קוד אימות מחדש
 * @param {Object} emailData - { email }
 * @returns {Promise} תוצאת שליחת הקוד החדש
 */
export const resendVerificationCode = async (email) => {
  try {
    const response = await customFetch.post('/users/resend-verification', { email });
    return response.data;
  } catch (error) {
    console.error('Error resending verification code:', error);
    throw error;
  }
};

/**
 * בדיקת סטטוס בקשת אימות
 * @param {string} email - כתובת המייל
 * @returns {Promise} סטטוס הבקשה
 */
export const checkVerificationStatus = async (email) => {
  try {
    const response = await customFetch.get(
      `/users/verification-status?email=${encodeURIComponent(email)}`
    );
    return response.data;
  } catch (error) {
    console.error("Error checking verification status:", error);
    throw error;
  }
};

// ========================================
// פונקציות ניהול משתמשים (אדמין בלבד)
// ========================================

// קבלת כל המשתמשים
export const getAllUsers = async () => {
  try {
    const response = await customFetch.get("/users/all");
    return response.data;
  } catch (error) {
    console.error("Error getting all users:", error);
    throw error;
  }
};

// קבלת משתמשים ממתינים לאישור
export const getPendingUsers = async () => {
  try {
    const response = await customFetch.get("/users/pending");
    return response.data;
  } catch (error) {
    console.error("Error getting pending users:", error);
    throw error;
  }
};

// אישור משתמש
export const approveUser = async (userId) => {
  try {
    const response = await customFetch.post(`/users/approve/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error approving user:", error);
    throw error;
  }
};

// דחיית משתמש
export const rejectUser = async (userId, reason) => {
  try {
    const response = await customFetch.post(`/users/reject/${userId}`, {
      reason,
    });
    return response.data;
  } catch (error) {
    console.error("Error rejecting user:", error);
    throw error;
  }
};

// חסימת משתמש
export const blockUser = async (userId) => {
  try {
    const response = await customFetch.post(`/users/block/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error blocking user:", error);
    throw error;
  }
};

// הסרת חסימה
export const unblockUser = async (userId) => {
  try {
    const response = await customFetch.post(`/users/unblock/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error unblocking user:", error);
    throw error;
  }
};

// שליחת מייל איפוס סיסמה למשתמש
export const sendPasswordResetToUser = async (userId) => {
  try {
    const response = await customFetch.post(
      `/users/send-password-reset/${userId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error sending password reset:", error);
    throw error;
  }
};

// ========================================
// פונקציות מידע ותחזוקה (אדמין בלבד)
// ========================================

/**
 * קבלת מידע על בקשות אימות ממתינות
 * @returns {Promise} כמות בקשות ממתינות ופגות תוקף
 */
export const getPendingVerifications = async () => {
  try {
    const response = await customFetch.get("/users/pending-verifications");
    return response.data;
  } catch (error) {
    console.error("Error getting pending verifications:", error);
    throw error;
  }
};

/**
 * קבלת סטטיסטיקות מערכת
 * @returns {Promise} סטטיסטיקות כלליות על המשתמשים
 */
export const getSystemStats = async () => {
  try {
    const response = await customFetch.get("/users/system-stats");
    return response.data;
  } catch (error) {
    console.error("Error getting system stats:", error);
    throw error;
  }
};

/**
 * נקיון אוטומטי של בקשות אימות ישנות
 * @returns {Promise} תוצאת הנקיון
 */
export const cleanupExpiredRegistrations = async () => {
  try {
    const response = await customFetch.post("/users/cleanup-expired");
    return response.data;
  } catch (error) {
    console.error("Error cleaning up expired registrations:", error);
    throw error;
  }
};

// ========================================
// פונקציות עזר ווואלידציה
// ========================================

/**
 * ואלידציה של כתובת מייל
 * @param {string} email - כתובת המייל לבדיקה
 * @returns {boolean} האם המייל תקין
 */
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * ואלידציה של קוד אימות (6 ספרות)
 * @param {string} code - הקוד לבדיקה
 * @returns {Object} תוצאת הבדיקה
 */
export const validateVerificationCode = (code) => {
  const cleanCode = String(code).trim();

  if (cleanCode.length !== 6) {
    return { isValid: false, message: "קוד חייב להיות בן 6 ספרות" };
  }

  if (!/^\d{6}$/.test(cleanCode)) {
    return { isValid: false, message: "קוד חייב להכיל רק ספרות" };
  }

  return { isValid: true, message: "קוד תקין" };
};

/**
 * פורמט זמן המתנה (שניות לפורמט mm:ss)
 * @param {number} seconds - מספר השניות
 * @returns {string} זמן מפורמט
 */
export const formatWaitTime = (seconds) => {
  if (seconds <= 0) return "0:00";

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

// ========================================
// פונקציות localStorage לניהול מצב
// ========================================

/**
 * שמירת מייל בהמתנה לאימות
 * @param {string} email - כתובת המייל
 */
export const savePendingEmail = (email) => {
  try {
    localStorage.setItem("pendingVerificationEmail", email);
  } catch (error) {
    console.warn("Could not save pending email to localStorage:", error);
  }
};

/**
 * קבלת מייל בהמתנה לאימות
 * @returns {string|null} כתובת המייל או null
 */
export const getPendingEmail = () => {
  try {
    return localStorage.getItem("pendingVerificationEmail");
  } catch (error) {
    console.warn("Could not get pending email from localStorage:", error);
    return null;
  }
};

/**
 * מחיקת מייל בהמתנה (לאחר אימות מוצלח)
 */
export const clearPendingEmail = () => {
  try {
    localStorage.removeItem("pendingVerificationEmail");
  } catch (error) {
    console.warn("Could not clear pending email from localStorage:", error);
  }
};

// ========================================
// דיפולט אקספורט (לתאימות לאחור)
// ========================================

const userApi = {
  // פונקציות קיימות
  getSectors,
  loginUser,
  loginAdmin,
  logoutUser,
  getUserProfile,
  checkAuth,
  registerUser, // ישן - לא מומלץ
  resetPassword,

  // פונקציות חדשות - אימות מייל
  requestEmailVerification,
  verifyEmailAndRegister,
  resendVerificationCode,
  checkVerificationStatus,

  // ניהול משתמשים
  getAllUsers,
  getPendingUsers,
  approveUser,
  rejectUser,
  blockUser,
  unblockUser,
  sendPasswordResetToUser,

  // מידע ותחזוקה
  getPendingVerifications,
  getSystemStats,
  cleanupExpiredRegistrations,

  // עזרים
  validateEmail,
  validateVerificationCode,
  formatWaitTime,
  savePendingEmail,
  getPendingEmail,
  clearPendingEmail,
};

export default userApi;
